import ReactPlayer from "react-player";
import Modal from "components/Modal";

interface IWatchDemoModalProps {
  open: boolean;
  toggleModal: VoidFunction;
  url: string;
  title?: string;
  content?: string;
}

export default function WatchDemoModal({
  open,
  toggleModal,
  url,
  title,
  content
}: Readonly<IWatchDemoModalProps>) {
  return (
    <Modal
      isOpen={open}
      closeModal={toggleModal}
      wrapperClass="!my-auto desktop:!min-h-fit desktop:!w-1/2"
      dialogClass="!bg-foreground !gap-3 !pt-8">
      {title && <h3 className="text-2xl">{title}</h3>}

      <div className="h-full overflow-y-auto">
        {content && (
          <div className="text-xs desktop:text-sm">
            <p className="py-2">
              We recommend including as many states as possible in order to get the full spectrum of
              new available verified direct shipper loads so you don’t miss any potential new
              customers!
            </p>
          </div>
        )}

        <ReactPlayer url={url} playing={false} controls={true} width="100%" />
      </div>
    </Modal>
  );
}
